import { Navigate } from "react-router-dom";
import ReferralPortalLayout from "./layout/ReferralPortalLayout";
import RequireReferralPartner from "./guards/RequireReferralPartner";
import LeadFormPage from "./pages/Leads/LeadFormPage";
import DocumentsPage from "./pages/Documents/DocumentsPage";
import DocumentRequestDetailPage from "./pages/Documents/DocumentRequestDetailPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import NotificationsPage from "./pages/Notifications/NotificationsPage";
import ClientsPage from "./pages/Clients/ClientsPage";
import ClientDetailPage from "./pages/Clients/ClientDetailPage";
import TasksPage from "./pages/Tasks/TasksPage";
import TaskDetailPage from "./pages/Tasks/TaskDetailPage";
import PriceListPage from "./pages/PriceList/PriceListPage";
import CheckListPage from "./pages/CheckList/CheckListPage";
import CoursesPage from "./pages/Courses/CoursesPage";
import CourseDetailPage from "./pages/Courses/CourseDetailPage";
import AppointmentsPage from "./pages/Appointments/AppointmentsPage";
import PaymentsPage from "./pages/Payments/PaymentsPage";
import AlertsPage from "./pages/Alerts/AlertsPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import HelpPage from "./pages/Help/HelpPage";
import TrainingPage from "./pages/Training/TrainingPage";
import StartPage from "./pages/Start/StartPage";
import AllOffersPage from "./pages/Offers/AllOffersPage";
import OfferDetailPage from "./pages/Offers/OfferDetailPage";
import NewSupportTicketPage from "./pages/Help/NewSupportTicketPage";
import SupportTicketPage from "./pages/Help/SupportTicketPage";

/**
 * Partner workspace. Every route sits behind RequireReferralPartner: the backend answers 401 for
 * anonymous visitors and 403 for callers with no active partner profile, and the guard turns those
 * into screens. Entry: /partner goes to /partner/dashboard.
 *
 * /partner/start is deliberately outside the guard. It is the screen that creates the very profile
 * the guard asks for, so guarding it would leave a member of the office with no way in.
 */
const PartnerRoutes = {
  path: "/partner",
  children: [
    { path: "start", element: <StartPage /> },
    {
      element: (
        <RequireReferralPartner>
          <ReferralPortalLayout />
        </RequireReferralPartner>
      ),
      children: [
        { index: true, element: <Navigate to="dashboard" replace /> },
        { path: "dashboard", element: <DashboardPage /> },
        { path: "offers", element: <AllOffersPage /> },
        { path: "offers/:offerId", element: <OfferDetailPage /> },
        { path: "notifications", element: <NotificationsPage /> },
        { path: "leads", element: <Navigate to="/partner/clients?tab=leads" replace /> },
        { path: "leads/:leadId/form", element: <LeadFormPage /> },
        { path: "documents", element: <DocumentsPage /> },
        { path: "documents/:requestId", element: <DocumentRequestDetailPage /> },
        { path: "clients", element: <ClientsPage /> },
        { path: "clients/:clientId", element: <ClientDetailPage /> },
        { path: "tasks", element: <TasksPage /> },
        { path: "tasks/:taskId", element: <TaskDetailPage /> },
        { path: "price-list", element: <PriceListPage /> },
        { path: "check-list", element: <CheckListPage /> },
        { path: "courses", element: <CoursesPage /> },
        { path: "courses/:courseId", element: <CourseDetailPage /> },
        { path: "appointments", element: <AppointmentsPage /> },
        { path: "payments", element: <PaymentsPage /> },
        { path: "alerts", element: <AlertsPage /> },
        { path: "settings", element: <SettingsPage /> },
        { path: "help", element: <HelpPage /> },
        { path: "help/tickets/new", element: <NewSupportTicketPage /> },
        { path: "help/tickets/:ticketId", element: <SupportTicketPage /> },
        { path: "training", element: <TrainingPage /> },
      ],
    },
  ],
};

export default PartnerRoutes;
